var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pt-15 text-gray-2 text-14"},[_c('h5',{staticClass:"font-semibold"},[_vm._v("\n    "+_vm._s(_vm.name)+":\n  ")]),_vm._v(" "),_vm._l((_vm.description),function(text){return _c('p',{key:text},[_vm._v("\n    "+_vm._s(text)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }